import { useImmerAtom } from 'jotai-immer';
import { useAtomValue } from 'jotai/utils';
import { diagnosisBaseAtom, getDiseaseDetailAtom } from './atom';

const useHandleInputBoxChange = () => {
  const diseaseDetailAtom = useAtomValue(getDiseaseDetailAtom);
  const [, setDiseaseDetail] = useImmerAtom(diseaseDetailAtom);
  const handleInputBoxChange = ({ field }) => event => {
    const newValue = event?.target?.value;
    setDiseaseDetail(prev => (prev[field] = newValue));
  };
  return { handleInputBoxChange };
};

const useHandleEventValue = ({ setImmerState }) => {
  const handleClick = fieldName => e => {
    const newValue = e.target.value;

    setImmerState(prev => {
      // eslint-disable-next-line no-param-reassign
      prev[fieldName] = newValue;
    });
  };
  return handleClick;
};

export { useHandleInputBoxChange, useHandleEventValue };
